(function(){
  'use strict';
  function init(root){
    if(root.__lfScrollCleanup)return;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    var header=document.querySelector('[data-lf-header],.site-header,.lf-header');
    var connection=navigator.connection;
    function measure(){
      root.style.setProperty('--lf-sequence-header',(header?header.getBoundingClientRect().height:0)+'px');
    }
    var resize=window.ResizeObserver?new ResizeObserver(measure):null;
    if(resize&&header)resize.observe(header);
    window.addEventListener('resize',measure,{passive:true});
    measure();
    function stop(){
      if(window.LFImageSequence)window.LFImageSequence.destroyIn(root);
      root.removeAttribute('data-lf-sequence');root.classList.add('is-static');root.classList.remove('is-ready','is-video');
      var intro=root.querySelector('[data-lf-sequence-intro]');
      if(intro){intro.classList.add('is-visible');intro.setAttribute('aria-hidden','false');}
      var copy=root.querySelector('[data-lf-sequence-copy]');
      if(copy){copy.classList.add('is-empty');copy.setAttribute('aria-hidden','true');}
    }
    function start(){
      stop();
      if(reduced.matches||(connection&&connection.saveData)||!window.LFImageSequence)return;
      root.classList.remove('is-static');root.setAttribute('data-lf-sequence','');
      window.LFImageSequence.initIn(root);
    }
    root.addEventListener('lf-sequence-error',stop);reduced.addEventListener('change',start);
    root.__lfScrollCleanup=function(){
      root.removeEventListener('lf-sequence-error',stop);
      reduced.removeEventListener('change',start);
      window.removeEventListener('resize',measure);
      if(resize)resize.disconnect();
      stop();delete root.__lfScrollCleanup;
    };
    start();
  }
  function rootsIn(scope,callback){
    if(scope.matches&&scope.matches('[data-lf-scroll-root]'))callback(scope);
    if(scope.querySelectorAll)scope.querySelectorAll('[data-lf-scroll-root]').forEach(callback);
  }
  function scan(scope){rootsIn(scope,init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document);},{once:true});else scan(document);
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  document.addEventListener('shopify:section:unload',function(e){rootsIn(e.target,function(root){if(root.__lfScrollCleanup)root.__lfScrollCleanup();});});
})();
